import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useUnassignReservationMutation } from "../../../store/api/school/ReservationSlice";
import { toast } from "react-toastify";

const UnassignDriverModal = ({
  show,
  onHide,
  reservationId,
  driverName,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const [unassignReservation, { isLoading: isUnassigning }] =
    useUnassignReservationMutation();

  const handleConfirm = async () => {
    try {
      await unassignReservation(reservationId).unwrap();
      toast.success(t("driver_unassigned_success"));
      onHide();
      onSuccess?.();
    } catch (err) {
      toast.error(err?.data?.message || t("unassign_driver_failed"));
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      className="Model"
    >
      <Modal.Header closeButton className="border-0 position-relative">
        <Modal.Title className="w-100 text-center">
          <h4 className="mb-0 fw-bold text-white">
            <i className="fas fa-user-times me-2"></i>
            {t("unassign_driver")}
          </h4>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <div className="mb-3">
          <div className="info-body text-center p-3">
            <p className="mb-3" style={{ fontSize: "0.9rem" }}>
              {t("unassign_driver_warning", { driverName })}
            </p>
            <div
              className="p-2 text-center"
              style={{
                background: "#fff3cd",
                border: "1px solid #ffc107",
                borderRadius: "8px",
                fontSize: "0.82rem",
                color: "#856404",
              }}
            >
              ⚠️ {t("unassign_driver_permanent")}
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-0">
        <div className="text-center">
          <Button
            className="smallBtn cancel me-3"
            onClick={onHide}
            disabled={isUnassigning}
          >
            {t("btns.cancel")}
          </Button>
          <Button
            className="smallBtn auto"
            onClick={handleConfirm}
            disabled={isUnassigning}
          >
            {isUnassigning ? (
              <div className="spinner-border" role="status">
                <span className="sr-only p-0"></span>
              </div>
            ) : (
              t("yes_unassign")
            )}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default UnassignDriverModal;
